  <div #historyToggleButton *ngIf="statusMessages.length > 0 && !isLoadingStatusMessages && !statusMessageInitializationError"
     class="is-flex is-justify-content-center is-align-items-center is-flex-direction-column timeline-expand-button-container">
  <div data-cy="history-toggle-button" (click)="toggleVisibility()"
      class="has-border is-flex is-align-items-center is-justify-content-center background-is-gray is-round timeline-expand-button is-clickable hover-container">
    <fa-icon *ngIf="isHidden" [icon]="faAngleDown"></fa-icon>
    <fa-icon *ngIf="!isHidden" [icon]="faAngleUp"></fa-icon>
  </div>
</div>

<div class="card has-round-border background-is-gray margin-auto relative" #statusMessageContent>

  <div *ngIf="isLoadingStatusMessages">
    <p class="ml-4 mt-4">
      <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'30%'}" appearance="line"
                           count="1"></ngx-skeleton-loader>
    </p>
    <p class="ml-4 mb-5">
      <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'50%'}" appearance="line"
                           count="1"></ngx-skeleton-loader>
    </p>
    <p class="ml-4">
      <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'98%'}" appearance="line"
                           count="1"></ngx-skeleton-loader>
    </p>
  </div>

  <div *ngIf="statusMessageInitializationError" class="columns is-flex-direction-column mb-2 mt-2">
    <div class="column is-flex is-justify-content-center is-align-items-center">
      <img alt="Attention Icon" src="assets/images/status-messages/info_attention_icon.svg">
    </div>
    <div class="column has-text-centered">
      <p>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut. Falls das Problem weiterhin besteht, kontaktieren Sie bitte untenstehend unseren Support.</p>
    </div>
  </div>

  <div data-cy="no-status-message-container" *ngIf="statusMessages.length < 1 && !isLoadingStatusMessages && !statusMessageInitializationError" class="column">
    <p class="is-size-7">Aktuell sind keine Informationen verfügbar.</p>
  </div>

  <ng-container *ngIf="statusMessages.length > 0 && !isLoadingStatusMessages && !statusMessageInitializationError">
    <div data-cy="status-message-header-container" class="column">
      <p class="is-size-7">Aktueller Status
        vom {{statusMessages[statusMessages.length - 1].date | date:'dd.MM.yyyy HH:mm' : 'CET'}} Uhr:</p>

      <div class="is-flex mb-1">
        <p class="is-size-7 is-bold">
          {{StatusMessageUtils.getStatusMessageText(statusMessages[statusMessages.length - 1])}}
        </p>
      </div>
      <div class="is-flex mb-5">
        <p class="is-size-7 is-bold">
          <span *ngIf="!StatusMessageUtils.isLatestStatusMessageCompletionStatus(isLoadingStatusMessages, statusMessages)">
            <span *ngIf="StatusMessageUtils.isLatestStatusMessageCustomerInteractionStatus(isLoadingStatusMessages, statusMessages) else showExpectedResponseDate">
              <span class="color-light-red">Die Bearbeitung ist pausiert, da wir auf Ihre Handlung angewiesen sind.</span>
            </span>
          </span>
        </p>
        <div data-cy="status-message-ci-response-button" *ngIf="relevantCustomerInteraction" routerLink="/customer-interaction/{{relevantCustomerInteraction.id}}"
             [state]="[property]"
             class="is-flex is-justify-content-center ml-2 customer-interaction-button-container is-clickable">
          <p class="is-size-7 mr-1 truncate" appTooltip matTooltip="Information(en) bereitstellen">Information(en) bereitstellen</p>
          <div class="is-flex is-justify-content-space-evenly is-align-items-center ml-1">
            <img class="upload-icon" alt="Download Icon" src="assets/images/status-messages/upload_icon.svg">
          </div>
        </div>
      </div>
    </div>
    <div data-cy="expandable-status-history" *ngIf="!isHidden">
      <p class="is-size-7 mt-3 mb-4 pl-4">Historie</p>
      <div class="columns mb-6" [ngClass]="{'mb-45-rem': !isHidden}">
        <div data-cy="status-message-container" class="column is-flex is-justify-content-space-between timestamp-container">
          <div [attr.data-cy]="'status-message-container_' + index" *ngFor="let statusMessage of statusMessages; let first = first; let last = last; let index = index">
            <div data-cy="status-message-tooltip-container" appCustomTooltip #tooltipElement [tooltipTemplate]="statusMessageTooltip"
                 (mouseover)="updateHoveredStatusMessage(statusMessage)" class="z-index-1 relative">
              <div data-cy="central-status-message-timestamp" *ngIf="!first && !last" class="timestamp has-background-black"></div>

              <div *ngIf="first" class="image-icon-container">
                <img data-cy="first-status-message-timestamp-image" class="image-icon" alt="Order Created" src="assets/images/status-messages/order_placed_icon.svg">
              </div>

              <div *ngIf="last">
                <div data-cy="last-status-message-timestamp" *ngIf="!StatusMessageUtils.getImageForStatusMessage(isLoadingStatusMessages, statusMessages) else iconImage"
                     class="timestamp has-background-yellow"></div>
                <ng-template #iconImage>
                  <div class="image-icon-container">
                    <img data-cy="last-status-message-timestamp-image" class="image-icon" alt="Status Icon"
                         src="{{StatusMessageUtils.getImageForStatusMessage(isLoadingStatusMessages, statusMessages)}}">
                  </div>
                </ng-template>
              </div>
              <div class="has-text-centered p-1 pt-4 is-size-7 timestamp-date">
                <span class="has-text-weight-normal" [ngClass]="{'has-text-weight-bold': last}">{{statusMessage.date | date:'dd.MM.yyyy' : 'CET'}}</span>
                <p class="has-text-weight-light" [ngClass]="{'has-text-weight-medium': last}">{{statusMessage.date | date:'HH:mm' : 'CET'}} Uhr</p>
              </div>
            </div>
          </div>
          <div class="dashed-time-line"></div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #statusMessageTooltip>
  <div data-cy="status-message-tooltip" class="card p-3 has-round-border">
    <p class="has-text-centered max-width-250">{{StatusMessageUtils.getStatusMessageText(hoveredStatusMessage)}}</p>
  </div>
</ng-template>

<ng-template #showExpectedResponseDate>
  <span *ngIf="documents && documents.length === 1"> Die Auskunft trifft vorraussichtlich am {{documents[0].expectedResponseDate | date: 'dd.MM.yyy'}} ein.</span>
  <span *ngIf="documents && documents.length > 1">Die Auskünfte sind vorraussichtlich zum {{getLatestExpectedResponseDateForDocuments() | date: 'dd.MM.yyyy'}} eingetroffen.</span>
</ng-template>
